module.exports = __webpack_public_path__ + "static/media/clima.16c1c021.PNG";